export class JanglDateController {
    constructor(dateService) {
        this.days = dateService.getDaysOptions();
        this.months = dateService.getMonthsOptions();
        this.years = [];
        this.dateErrors = '';
    }

    $onInit() {
        // validate options.
        if (!this.yearMin || !this.yearMax) throw new Error(this.name + ': Years range should be defined', this.name);
        this.required = this.required || false;
        if (angular.isString(this.model)) this.model = this.buildDropdownDate(this.model);

        let yearMin = parseInt(this.yearMin);
        let yearMax = parseInt(this.yearMax);
        let year = new Date().getFullYear();

        for(let i = 0; yearMin + i <= yearMax; i++) {
            let key = year + yearMin + i;
            this.years.push({ key: key, label: key });
        }

        if (this.yearReverse) {
            this.years = this.years.reverse();
        }
    }

    /**
     * Update dateErrors and check that the provided date is valid
     */
    updateDate() {
        this.dateErrors = '';
        if (this.model.day && this.model.month && this.model.year) {
            let date = new Date(this.model.year, this.model.month, this.model.day);
            if (date.getMonth() !== this.model.month || date.getDate() !== this.model.day){
                this.dateErrors = 'Invalid date';
            }
        }
    }

    /**
     * convert a string date to an {day: n, month: n, year:n} object.
     * @param 'YYYY-MM-DD'|'MM/DD/YYYY' String - date to be converted.
     * @return Object - {day: n, month: n, year:n} formatted date.
     */
    buildDropdownDate(data) {
        let date = new Date(data);
        if (date.getDate()) {
            return { day: date.getDate(), month: date.getMonth(), year: date.getFullYear() };
        } else {
            return null;
        }
    }
}
JanglDateController.$inject = ['janglDateService'];

export default JanglDateController;



// WEBPACK FOOTER //
// ./app/jangl/jangl-date/controller.js